class Controller {
  constructor($injector, Sections, $stateParams) {
    "ngInject";

    this.Events = $injector.get("Events");
    this.$stateParams = $stateParams;
    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;
    this.sections = Sections.settingsSections;

    this.filterEvent = this.Events.getFilterEvent("credits");
    this.paginateEvent = this.Events.getPaginateEvent("credits");
    this.sortEvent = this.Events.getSortEvent("credits");
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/credits/credits.controller.js